import React from 'react';
import type LiveChatTeamChatsType from '@atlassian/jira-spa-apps-servicedesk-live-chat-team-chats/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyLiveChatTeamChats = lazyForPaint<typeof LiveChatTeamChatsType>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-live-chat-team-chats", jiraSpaEntry: "async-servicedesk-live-chat-team-chats" */ '@atlassian/jira-spa-apps-servicedesk-live-chat-team-chats'
		),
);

const AsyncLiveChatTeamChats = (): React.JSX.Element => (
	<LazyPage
		Page={LazyLiveChatTeamChats}
		pageId="spa-apps/servicedesk/live-chat/team-chats"
		shouldShowSpinner
	/>
);

export default AsyncLiveChatTeamChats;
